var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnii(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 580 164",
    width: 400,
    height: 113,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LOGOTIPO ANII_RGB-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m2.3 4.1h135.4v155.8h-135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m149 4.1h135.4v155.8h-135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m295.6 4.1h135.4v155.8h-135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m442.3 4.1h135.4v155.8h-135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m399.2 37.9l1.3 1.3v13.8l-1.3 1.3h-26.9v55.4h26.9l1.3 1.3v13.8l-1.3 1.3h-71.8l-1.2-1.3v-13.8l1.2-1.3h27v-55.4h-27l-1.2-1.3v-13.8l1.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m545.9 37.9l1.3 1.3v13.8l-1.3 1.3h-26.9v55.4h26.9l1.3 1.3v13.8l-1.3 1.3h-71.8l-1.3-1.3v-13.8l1.3-1.3h26.9v-55.4h-26.9l-1.3-1.3v-13.8l1.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m252.5 37.9h-15.4l-1.3 1.3v42.1l-38.3-27.9v-14.2l-1.3-1.3h-15.4l-1.2 1.3v85.7l1.2 1.2h15.4l1.3-1.2v-49.4l38.3 27.9v21.5l1.3 1.2h15.4l1.2-1.2v-85.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m92.6 111.3h-45.2v-16.4h45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m70.6 60.2l18.7 34.6v30l1.2 1.3h15.4l1.3-1.3v-34.5l-27.8-51.1-1.6-1.3h-15.6l-1.7 1.3-27.7 51.1v34.5l1.3 1.3h15.4l1.2-1.3v-30l18.7-34.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnii);
export default __webpack_public_path__ + "static/media/anii.70a3f63bb5ecfff9d5cdf52c5d731426.svg";
export { ForwardRef as ReactComponent };